module.exports = __webpack_public_path__ + "static/media/charlemange.d1dcfa99.png";